import { App, reactive } from 'vue'
import { initPlugin as initPluginConfig, reactiveLayout } from '@/plugin'
import { notification } from 'ant-design-vue'
import menu from '../data/menu'

export const initPlugin = function (app: App): App {
  return initPluginConfig(app, () => {
    reactiveLayout.installMod('sider', reactive({
      width: menu.collapsed ? 80 : 200,
      change() {
        this.width = menu.collapsed ? 80 : 200
      }
    }))
    reactiveLayout.installMod('header', {
      height: 60
    })

    notification.config({
      placement: 'topRight',
      top: '70px',
      duration: 6
    })
  })
}
